import * as yup from "yup";
export const formFields: any = [
    {
        label: "Job Title",
        type: 'text',
        name: 'job_title',
        placeholder: 'Enter Job Title'
    },
    {
        label: "Location",
        type: 'text',
        name: 'location',
        placeholder: 'Enter Location'
    },
    {
        label: "Job Description",
        type: 'textarea',
        name: 'job_description',
        placeholder: 'Enter Job Description'
    }
]

export const validationSchema = yup.object({
    job_title: yup.string().ensure().required("Job Title is required!").min(3, 'To short!'),
    location: yup.string().ensure().required("Location is required!").min(3, 'To short!'),
    // job_description: yup.string().ensure().required("Job Description is required!").min(3, 'To short!')
});